module.exports = __webpack_public_path__ + "static/img/sales_poster_two_new_2.08c98d1e.jpg";